"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Route_1 = require("react-router-dom/Route");
var Redirect_1 = require("react-router-dom/Redirect");
var UnauthRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UnauthRoute, _super);
    function UnauthRoute(props, context) {
        return _super.call(this, props, context) || this;
    }
    UnauthRoute.prototype.render = function () {
        var _a = this.props, isAuthenticated = _a.isAuthenticated, fallbackPath = _a.fallbackPath, Component = _a.component, others = tslib_1.__rest(_a, ["isAuthenticated", "fallbackPath", "component"]);
        return (React.createElement(Route_1.default, tslib_1.__assign({}, others, { render: function (props) { return (!isAuthenticated
                ? React.createElement(Component, tslib_1.__assign({}, props))
                : React.createElement(Redirect_1.default, { to: { pathname: fallbackPath } })); } })));
    };
    UnauthRoute.defaultProps = {
        fallbackPath: "/"
    };
    return UnauthRoute;
}(React.Component));
exports.default = UnauthRoute;
